
import * as angular from "angular";

export class Config {

    constructor($httpProvider: angular.IHttpProvider) {

        $httpProvider.useApplyAsync(true);
        //this._http.defaults.timeout = 5000;

        delete $httpProvider.defaults.headers.common["X-Requested-With"];
    }
}

angular
    .module("app.components.util", ["app.components.util.api"])
    .config(["$httpProvider", Config]);
